import React, { useEffect, useState } from "react";
import classes from "./ConfigureHeader.module.css";
import { toast } from "react-toastify";
import { useIndentTracking } from "../Components/Indent/hooks/useIndentTracking";

const HeaderMap = ({
  isConfigureScreen = false,
  setFormats,
  setFinalKeys,
  setStep,
  data,
  formats,
  finalKeys,
  selectedIndex,
}) => {
  const [additionalField, setAdditionalField] = useState("");
  const [nextLevel, setNextLevel] = useState(2);
  const [headerItems, setHeaderItems] = useState([
    { label: "Sr No", key: "S No.", required: true },
    { label: "Origin Name", key: "Origin Name*", required: true }, //Lorri Header - User selected Header
    { label: "Origin State", key: "Origin State*", required: true },
    { label: "Destination Name", key: "Destination Name*", required: true },
    { label: "Destination State", key: "Destination State*", required: true },
    { label: "Truck Type", key: "Truck Type*", required: true },
    { label: "No. of Trucks", key: "Annual Volume*", required: true },
    { label: "Date of Placement", key: "Date of Placement", required: true }, //TBD
    { label: "Transit Time", key: "Transit Time (Days)*", required: true },
    { label: "L1 Transporters", key: "L1 Transporter Name*", required: true },
    {
      label: "L1 Freight Rate",
      key: "L1 Transporter Freight Rate*",
      required: true,
    },
    {
      label: "L1 Business Share(%)",
      key: "L1 Transporter Share of business (%)",
      required: true,
    },
  ]);
  const [selectedEmptyColumns, setSelectedEmptyColumns] = useState(
    new Array(headerItems.length).fill(false)
  );

  const {trackIndentEvent} = useIndentTracking()

  useEffect(() => {
    const headerMap = formats?.[selectedIndex]?.header_map ?? {};
    const hasHeaderMap = Object.keys(headerMap).length > 0;

    setHeaderItems((prev) => {
      let updated = [...prev];

      const l2Keys = [
        { label: "L2 Transporters", key: "L2 Transporter Name" },
        { label: "L2 Freight Rate", key: "L2 Transporter Freight Rate" },
        {
          label: "L2 Business Share(%)",
          key: "L2 Transporter Share of business (%)",
        },
      ];

      if (
        (!finalKeys || Object.keys(finalKeys).length === 0) &&
        !hasHeaderMap
      ) {
        l2Keys.forEach((field) => {
          if (!updated.some((item) => item.key === field.key)) {
            updated.push({ ...field, required: false, newField: true });
          }
        });
      }

      if (finalKeys && Object.keys(finalKeys).length > 0) {
        Object.keys(finalKeys).forEach((key) => {
          if (!updated.some((item) => item.key === key)) {
            updated.push({
              label: key,
              key,
              required: true,
              newField: true,
            });
          }
        });
      }

      return updated;
    });
  }, []);

  useEffect(() => {
    const regex = /^L(\d+)\s/i;
    let maxL = 0;

    headerItems.forEach((item) => {
      const match = item.label.match(regex);
      if (match && match[1]) {
        maxL = Math.max(maxL, parseInt(match[1], 10));
      }
    });

    setNextLevel(maxL + 1); // always next available level
  }, [headerItems]);

  const handleChangeForMap = (value, key, index, show) => {
    let updatedFinalKeys = { ...finalKeys };
    if (
      (value === null || value === "" || value === undefined) &&
      finalKeys?.[key] !== undefined
    ) {
      delete updatedFinalKeys[key];
    } else {
      updatedFinalKeys[key] = value;
    }
    setFinalKeys(updatedFinalKeys);
    const updatedColumns = [...selectedEmptyColumns];
    // if (emptyColumns?.includes(value)) {
    //   updatedColumns[index] = true;
    // } else {
    updatedColumns[index] = false;
    // }
    setSelectedEmptyColumns(updatedColumns);
  };

  const addField = () => {
    if (!additionalField.trim()) {
      toast.error("Additional Field cannot be empty!");
      return;
    }

    if (headerItems.some((item) => item.key === additionalField)) {
      toast.error("Field already exists!");
      return;
    }

    setHeaderItems([
      ...headerItems,
      {
        label: additionalField,
        key: additionalField,
        required: true,
        newField: true,
      },
    ]);
    setAdditionalField("");
  };

  const addTransporter = () => {
    const regex = /^L(\d+)\s/i;

    let maxL = 0;
    headerItems.forEach((item) => {
      const match = item.label.match(regex);
      if (match && match[1]) {
        maxL = Math.max(maxL, parseInt(match[1], 10));
      }
    });

    const newLevel = maxL + 1;
    setNextLevel(newLevel);

    const newItems = [
      {
        label: `L${newLevel} Transporters`,
        key: `L${newLevel} Transporter Name`,
        required: false,
        newField: true,
      },
      {
        label: `L${newLevel} Freight Rate`,
        key: `L${newLevel} Transporter Freight Rate`,
        required: false,
        newField: true,
      },
      {
        label: `L${newLevel} Business Share(%)`,
        key: `L${newLevel} Transporter Share of business (%)`,
        required: false,
        newField: true,
      },
    ];

    setHeaderItems([...headerItems, ...newItems]);
  };

  const saveHeaderMapping = () => {
    const filteredKeysCount = Object.keys(finalKeys).filter(
      (key) => finalKeys[key] !== ""
    ).length;
    const isAllMandatoryFields = headerItems.every((item) => {
      return !item.required || finalKeys.hasOwnProperty(item.key);
    });
    const requiredFieldsCount = headerItems.filter(
      (item) => item.required
    ).length;

    if (!isAllMandatoryFields || filteredKeysCount < requiredFieldsCount) {
      toast.error("Please map all mandatory headers!");
      return false;
    }
    const updatedFormats = formats.map((item, index) => {
      if (index !== selectedIndex) return item;

      return {
        ...item,
        header_map: { ...finalKeys },
        all_keys: data,
        total_required_fields: requiredFieldsCount,
      };
    });
    setFormats(updatedFormats);
    setStep(0);

    trackIndentEvent("indent request", "user has clicked on save header mapping for bulk indent upload")

    toast.success(
      "Header Mapping saved successfully, Go back and submit the all details!"
    );
  };

  const removeField = (index, key) => {
    let updatedHeaders = [...headerItems];
    let updatedFinalKeys = { ...finalKeys };

    const levelMatch = key.match(/^L(\d+)\s/i);
    if (levelMatch) {
      const level = levelMatch[1];
      const groupKeys = [
        `L${level} Transporter Name`,
        `L${level} Transporter Freight Rate`,
        `L${level} Transporter Share of business (%)`,
      ];

      groupKeys.forEach((grpKey) => {
        if (updatedFinalKeys.hasOwnProperty(grpKey)) {
          delete updatedFinalKeys[grpKey];
        }
      });

      updatedHeaders = updatedHeaders.filter(
        (item) => !groupKeys.includes(item.key)
      );

      // Recalculate next level
      const regex = /^L(\d+)\s/i;
      let maxL = 0;
      updatedHeaders.forEach((item) => {
        const match = item.label.match(regex);
        if (match && match[1]) {
          maxL = Math.max(maxL, parseInt(match[1], 10));
        }
      });
      setNextLevel(maxL + 1);
    } else {
      if (updatedFinalKeys.hasOwnProperty(key)) {
        delete updatedFinalKeys[key];
      }
      updatedHeaders.splice(index, 1);
    }

    setFinalKeys(updatedFinalKeys);
    setHeaderItems(updatedHeaders);
  };

  return (
    <>
      <div className="d-flex align-items-center mt-2 mb-4">
        <strong style={{ marginRight: "10px" }}>Note:</strong>
        <ul
          className={`list-unstyled mb-0 d-flex flex-wrap w-75 ${
            isConfigureScreen === true && "flex-column"
          }`}
        >
          <li className="mr-4">
            1) Fields marked with <span className="text-danger">*</span> are{" "}
            <strong>Mandatory</strong>.
          </li>
          <li className="mr-4">
            2) Date of Placement should be in
            <strong> DD/MM/YYYY</strong> format.
          </li>
        </ul>
        {
          //   isConfigureScreen === true &&
          <span className="w-25 mr-5 justify-content-center d-flex align-items-center">
            <input
              className={classes.additonalInput}
              onChange={(e) => setAdditionalField(e.target.value)}
              value={additionalField}
              placeholder="Additional Field"
            />
            <button
              className="btn btn-sm btn-primary d-flex align-items-center ml-3"
              onClick={() => addField()}
              style={{ height: "26px" }}
            >
              +
            </button>
            {/* <button
              className="btn btn-sm btn-success ml-5"
              onClick={() => addTransporter()}
            >{`Add Transporter for L${nextLevel}`}</button> */}
          </span>
        }
      </div>

      <div
        className="d-flex flex-wrap"
        style={{ overflowY: "scroll", overflowX: "hidden", height: "65vh" }}
      >
        <span className="col-md-3 mb-1 font-weight-bold text-left p-0">
          LoRRI Headers
        </span>
        <span className="col-md-3 mb-1 font-weight-bold text-left p-0">
          File's Headers
        </span>
        <span className="col-md-3 mb-1 font-weight-bold text-left p-0">
          LoRRI Headers
        </span>
        <span className="col-md-3 mb-1 font-weight-bold text-left p-0">
          File's Headers
        </span>
        {headerItems.map(({ label, key, required, newField }, index) => (
          <div key={index} className="col-6 px-1 py-3">
            <div className="row d-flex align-items-center">
              <span className="col-md-6 mt-2" style={{ maxWidth: "45%" }}>
                {label} {required && <span className="text-danger">*</span>}
                <span className="px-1">
                  {selectedEmptyColumns[index] && (
                    <i
                      className="fa fa-exclamation-circle"
                      style={{ color: "orange" }}
                      aria-hidden="true"
                    ></i>
                  )}
                </span>
              </span>
              <select
                className="form-control col-md-6"
                onChange={(e) =>
                  handleChangeForMap(e.target.value, key, index, null)
                } // Pass the selected value
                style={{ maxWidth: "40%" }}
                value={finalKeys?.[key] || ""}
              >
                <option value="">Select</option>
                {data &&
                  data.length > 0 &&
                  data.map((item, itemIndex) => (
                    <option
                      key={itemIndex}
                      value={item.value}
                      style={{
                        backgroundColor:
                          finalKeys &&
                          Object.values(finalKeys).includes(item.value)
                            ? "#dbd7d7"
                            : "",
                      }}
                      disabled={
                        finalKeys &&
                        Object.values(finalKeys).includes(item.value)
                        // && finalKeys[item.value] !== item.label
                      }
                    >
                      {item.label}
                    </option>
                  ))}
              </select>
              {newField === true && (
                <button
                  onClick={() => removeField(index, key)}
                  style={{
                    height: "23px",
                    width: "21px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "3px",
                    marginLeft: "8px",
                    fontWeight: "bolder",
                    fontSize: "15px",
                    borderWidth: "2px",
                  }}
                  className="btn btn-sm btn-outline-danger"
                >
                  x
                </button>
              )}
            </div>
          </div>
        ))}
        {isConfigureScreen === true && (
          <div
            className="d-flex justify-content-center w-100 py-3 align-items-center"
            style={{
              bottom: "0",
              position: "sticky",
              backgroundColor: "white",
            }}
          >
            <button
              className="btn btn-sm btn-secondary mr-3"
              onClick={() => setStep(0)}
            >
              Back
            </button>
            <button
              className="btn btn-sm btn-success mx-5"
              onClick={() => saveHeaderMapping()}
            >
              Save
            </button>
          </div>
        )}
        <button
              className="btn btn-sm btn-primary"
              style={{ position: "absolute", bottom: "60px", right:"40px", marginTop: "-52px" }}
              onClick={() => addTransporter()}
            >{`Add Transporter for L${nextLevel}`}</button>
      </div>
    </>
  );
};

export default HeaderMap;
